const ONES = [
  'zero',
  'one',
  'two',
  'three',
  'four',
  'five',
  'six',
  'seven',
  'eight',
  'nine',
  'ten',
  'eleven',
  'twelve',
  'thirteen',
  'fourteen',
  'fifteen',
  'sixteen',
  'seventeen',
  'eighteen',
  'nineteen',
];
const TENS = ['', '', 'twenty', 'thirty', 'forty', 'fifty', 'sixty', 'seventy', 'eighty', 'ninety'];

function spellInteger(value) {
  const number = Math.floor(Number(value));
  if (!Number.isFinite(number) || number < 0) {
    return '';
  }
  if (number < 20) {
    return ONES[number];
  }
  if (number < 100) {
    const tens = Math.floor(number / 10);
    const ones = number % 10;
    return ones ? `${TENS[tens]}-${ONES[ones]}` : TENS[tens];
  }
  if (number < 1000) {
    const hundreds = Math.floor(number / 100);
    const remainder = number % 100;
    if (!remainder) {
      return `${ONES[hundreds]} hundred`;
    }
    return `${ONES[hundreds]} hundred ${spellInteger(remainder)}`;
  }
  return String(number);
}

export function formatNoShopDays(days) {
  if (days === '' || days == null || !Number.isFinite(Number(days))) {
    return '[]';
  }
  const number = Number(days);
  const spelled = spellInteger(number);
  return spelled ? `${number} (${spelled})` : String(number);
}

export function buildNoShopClause(fields) {
  const period = formatNoShopDays(fields.noShopDays);
  return `In consideration of Treisar's time, costs, and resources in evaluating and pursuing the proposed transaction, the Company agrees that, for a period of ${period} days from the date it signs this Term Sheet, or such longer period as may be agreed in writing, it shall not, and shall cause its directors, officers, employees, shareholders, representatives, and advisers not to, directly or indirectly, solicit, initiate, encourage, or engage in discussions or negotiations with any person other than Treisar concerning any transaction similar to the proposed transaction. The Company shall promptly notify Treisar of any unsolicited approach or proposal relating to any such transaction received during such period.`;
}
